import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';

const OtherTableColumns = ({columns, data, onClick}) => (<>
    <Grid.Column data-id={data.id} onClick={onClick} width={columns?.content_category_level_2?.width}>
        {data.content_category?.parent?.name}
    </Grid.Column>
    <Grid.Column data-id={data.id} onClick={onClick} width={columns?.content_category_level_3?.width}>
        {data.content_category?.name}
    </Grid.Column>
</>);

OtherTableColumns.propTypes = {
    columns: PropTypes.object.isRequired,
    data: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        content_category: PropTypes.shape({
            parent: PropTypes.shape({name: PropTypes.string}),
            name: PropTypes.string,
        }),
    }).isRequired,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
};

export default OtherTableColumns;

